module.exports = __webpack_public_path__ + "img/check-code.6d13798a.svg";